import { render, staticRenderFns } from "./fun_step_nav.vue?vue&type=template&id=31d65c2a&scoped=true&"
import script from "./fun_step_nav.vue?vue&type=script&lang=js&"
export * from "./fun_step_nav.vue?vue&type=script&lang=js&"
import style0 from "./fun_step_nav.vue?vue&type=style&index=0&id=31d65c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d65c2a",
  null
  
)

export default component.exports